// Config for the generic Admin Panel product editor — one entry per
// category migrated to MongoDB beyond the Wellside Canopies pilot (which
// keeps its own dedicated editor at AdminWellsideEditPage.jsx). Adding a new
// category here plus its storefront fetch switch is the entire rollout —
// no new backend collection or endpoint set is needed.
export const CATEGORY_CONFIGS = {
  "roof-tents": {
    category: "rooftent",
    label: "Roof Tents",
    storefrontPath: "/roof-tents",
    typeOptions: [
      { value: "hard-shell", label: "Hard Shell" },
      { value: "soft-shell", label: "Soft Shell" },
    ],
    hasVideo: true,
    hasPriceWas: true,
    hasHeroField: true,
    hasHiddenToggle: true,
  },
  awnings: {
    category: "awning",
    label: "Awnings",
    storefrontPath: "/awnings",
    typeOptions: [
      { value: "awning", label: "Awning" },
      { value: "accessory", label: "Accessory" },
    ],
    hasVideo: true,
    hasPriceWas: false,
    hasHeroField: true,
  },
  "bush-cabin": {
    category: "bushcabin",
    label: "Bush Cabin",
    storefrontPath: "/bush-cabin",
    typeOptions: [{ value: "cabin", label: "Bush Cabin" }],
    hasVideo: true,
    hasPriceWas: false,
    hasHeroField: true,
  },
  ensuites: {
    category: "ensuite",
    label: "Ensuites",
    storefrontPath: "/ensuites",
    typeOptions: [{ value: "ensuite", label: "Ensuite" }],
    hasVideo: false,
    hasPriceWas: false,
    hasHeroField: true,
  },
  "camp-cooking": {
    category: "cooking",
    label: "Camp Cooking",
    storefrontPath: "/camp-cooking",
    typeOptions: [{ value: "cooking", label: "Cooking" }],
    hasVideo: false,
    hasPriceWas: true,
    hasHeroField: true,
  },
  "camping-accessories": {
    category: "campingaccessory",
    label: "Camping Accessories",
    storefrontPath: "/camping-accessories",
    typeOptions: [{ value: "accessory", label: "Accessory" }],
    hasVideo: true,
    hasPriceWas: false,
    hasHeroField: true,
  },
  "ground-tents": {
    category: "groundtent",
    label: "Ground Tents",
    storefrontPath: "/ground-tents",
    typeOptions: [
      { value: "bow-tent", label: "Bow Tent" },
      { value: "safari-tent", label: "Safari Tent" },
      { value: "accessory", label: "Accessory" },
    ],
    hasVideo: true,
    hasPriceWas: false,
    hasSizes: true,
    hasSeasoning: true,
    hasHeroField: true,
  },
  "12v-fridges": {
    category: "fridge",
    label: "12V Fridges & Lighting",
    storefrontPath: "/12v-fridges",
    typeOptions: [
      { value: "fridge", label: "Fridge" },
      { value: "lighting", label: "Lighting" },
      { value: "power", label: "Power" },
    ],
    hasVideo: false,
    hasPriceWas: false,
    hasHeroField: true,
  },
  "wellside-accessories": {
    category: "wellsideaccessory",
    label: "Wellside Accessories",
    storefrontPath: "/wellside-accessories",
    typeOptions: [{ value: "accessory", label: "Accessory" }],
    hasVideo: false,
    hasPriceWas: false,
    hasHeroField: true,
  },
  "bull-bars": {
    category: "bullbar",
    label: "Bull Bars",
    storefrontPath: "/bull-bars",
    typeOptions: [
      { value: "front-bar", label: "Front Bar" },
      { value: "rear-bar", label: "Rear Bar" },
      { value: "slider", label: "Rock Slider" },
      { value: "wellside", label: "Wellside" },
      { value: "accessory", label: "Accessory" },
    ],
    hasVideo: false,
    hasPriceWas: false,
    hasVehicle: true,
    hasHeroField: true,
  },
  "roof-racks": {
    category: "roofrack",
    label: "Roof Racks",
    storefrontPath: "/roof-racks",
    typeOptions: [
      { value: "platform", label: "Platform Rack" },
      { value: "loadbar", label: "Load Bar" },
      { value: "mount", label: "Awning & Tent Mount" },
      { value: "accessory", label: "Accessory" },
    ],
    hasVideo: false,
    hasPriceWas: false,
    hasVehicle: true,
    hasVariants: true,
    hasHeroField: true,
  },
  "jimny-store": {
    category: "jimny",
    label: "Jimny Store",
    storefrontPath: "/jimny-store",
    typeOptions: [{ value: "accessory", label: "Accessory" }],
    hasVideo: false,
    hasPriceWas: false,
    hasHeroField: true,
  },
  "x-series-tray": {
    category: "xseries",
    label: "X-Series Tray",
    storefrontPath: "/x-series-tray",
    typeOptions: [{ value: "tray", label: "Tray & Canopy" }],
    hasVideo: true,
    hasPriceWas: false,
    hasVehicle: true,
    hasHeroField: true,
  },
  "drawers-kitchens-tables": {
    category: "drawer",
    label: "Drawers, Kitchens & Tables",
    storefrontPath: "/drawers-kitchens-tables",
    typeOptions: [
      { value: "drawers", label: "Drawers" },
      { value: "kitchen", label: "Kitchen" },
      { value: "fridge-slide", label: "Fridge Slide" },
      { value: "table", label: "Table" },
      { value: "storage", label: "Storage" },
    ],
    hasVideo: true,
    hasPriceWas: false,
    hasHeroField: true,
  },
  clearance: {
    category: "clearance",
    label: "Clearance",
    storefrontPath: "/clearance",
    typeOptions: [{ value: "clearance", label: "Clearance" }],
    hasVideo: false,
    hasPriceWas: true,
    hasCareNote: true,
    hasHeroField: true,
  },
  "bush-cabin-accessories": {
    category: "bushcabinaccessory",
    label: "Bush Cabin Accessories",
    storefrontPath: "/bush-cabin-accessories",
    typeOptions: [{ value: "accessory", label: "Accessory" }],
    hasVideo: false,
    hasPriceWas: false,
    hasHeroField: true,
  },
  "hard-lids": {
    category: "hardlid",
    label: "Hard Lids",
    storefrontPath: "/hard-lids",
    typeOptions: [
      { value: "vehicle", label: "Vehicle Fitment" },
      { value: "accessory", label: "Accessory" },
    ],
    hasVideo: false,
    hasPriceWas: false,
    hasVariants: true,
    hasHeroField: true,
  },
};

// Every sellable category's storefront-facing label, keyed by the same slug
// used throughout the Admin Panel — drives the "Category Order" drag-reorder
// screen and the fallback order below. Kept in sync with the live
// admin-configured order (GET /api/site-settings) so there's no flash of a
// different order on first paint before that fetch resolves.
export const CATEGORY_ORDER_LABELS = {
  "hard-lids": "Hard Lids (Tour Top Cover)",
  "wellside-canopies": "Wellside Canopies",
  "x-series-tray": "X-Series Tray & Canopy",
  "bush-cabin": "Bush Cabin Ute Camper",
  "wellside-accessories": "Bushtech Canopy Accessories (Bushtech menu only)",
  awnings: "Awnings",
  "roof-tents": "Roof Tents",
  "roof-racks": "K9 Roof Racks",
  "ground-tents": "Ground Tents",
  ensuites: "Ensuites & Related Products",
  "camping-accessories": "Unique Camping Accessories (Shop menu only)",
  "jimny-store": "Suzuki Jimny Store",
  "bull-bars": "Premium Bull Bars",
  "12v-fridges": "12V Fridges & LED Lighting",
  "drawers-kitchens-tables": "Drawers, Kitchens & Tables",
  "camp-cooking": "Camp Cooking",
  clearance: "Clearance & Specials",
  "bush-cabin-accessories": "Bush Cabin Accessories (Bushtech menu only)",
};

export const DEFAULT_CATEGORY_ORDER = Object.keys(CATEGORY_ORDER_LABELS);
